export const EXPERT_PROMPT_CATEGORIES = [
  {
    title: 'Yard Expert Agent',
    description: 'Focuses on inventory, spatial bins, dwell time, and capacity.',
    prompts: [
      "What is the current yard utilization percentage for the entire terminal? Calculate the total TEUs currently sitting in the yard against the maximum ground slot capacity.",
      "Show me the average container dwell time for all departed units in the last 7 days, grouped by whether the unit is a Reefer or Dry container.",
      "Give me a list of all units currently located in the yard that have been aging for more than 30 days, excluding any pseudo-blocks or wash areas."
    ]
  },
  {
    title: 'Quay (Vessel) Expert Agent',
    description: 'Focuses on vessel visits, load/discharge moves, and quay crane performance.',
    prompts: [
      "Calculate the overall berth productivity (total load and discharge moves divided by total elapsed port hours) for every vessel visit that departed in the past month.",
      "Show me the total number of LOAD moves and DSCH (discharge) moves performed specifically by Quay Cranes (QC) yesterday, grouped by crane.",
      "List the top 5 vessel visits with the highest number of continuous crane delays lasting over 10 minutes."
    ]
  },
  {
    title: 'CHE (Container Handling Equipment) Expert Agent',
    description: 'Focuses on RTG/Straddle Carrier productivity and move tracking.',
    prompts: [
      "Calculate the CHE productivity (average moves per hour) for each Rubber Tyred Gantry (RTG) active during the last 24 hours.",
      "Show me a breakdown of all equipment moves by kind (YARD vs LOAD vs DSCH vs REHANDLE) for each specific piece of equipment this week."
    ]
  },
  {
    title: 'Gate Expert Agent',
    description: 'Focuses on external truck visits, gate transactions, and turn times.',
    prompts: [
      "What is the average gate turn time (difference between time_in and time_out) for Drop Import (DI) transactions compared to Receive Export (RE) transactions today?",
      "List all external truck visits from yesterday where the gate turn time exceeded 2 hours, including the truck ID and the specific gate they used.",
      "Show me the total volume of gate transactions from the last 14 days, grouped by transaction type (DI, RE, DE, RM) and by day."
    ]
  }
];
